import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { LoginComponent } from "./modules/login/login.component";
import { ForgotPasswordComponent } from "./modules/forgot-password/forgot-password.component";
import { SetPasswordComponent } from "./modules/set-password/set-password.component";
import { LoggedInGuard } from "./guards/logged-in.guard";
import { NotLoggedInGuard } from "./guards/not-logged-in.guard";
import { ResetPasswordComponent } from "./modules/reset-password/reset-password.component";
import { ErrorPageComponent } from "@npm.chapps.com/chapps.common.angular.library";
import { JobComponent } from "./modules/jobs//details/job.component";
import { BuildingsComponent } from "./modules/buildings/buildings.component";
import { BuildingComponent } from "./modules/buildings/details/building.component";
import { OfflinePageComponent } from './modules/shared/components/offline-page/offline-page.component';
import { OfflineGuard } from './guards/offline.guard';

const routes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: 'offline-page', component: OfflinePageComponent },
  { path: "error-page", component: ErrorPageComponent },
  { path: "login", component: LoginComponent, canActivate: [OfflineGuard, NotLoggedInGuard] },
  { path: "forgot-password", component: ForgotPasswordComponent, canActivate: [OfflineGuard] },
  {
    path: "reset-password/:culture/:passwordResetCode",
    component: ResetPasswordComponent,
    canActivate: [OfflineGuard]
  },
  {
    path: "set-password/:culture/:confirmationCode",
    component: SetPasswordComponent,
    canActivate: [OfflineGuard]
  },
  {
    path: "buildings",
    component: BuildingsComponent,
    canActivate: [OfflineGuard, LoggedInGuard]
  },
  {
    path: "buildings/:buildingId",
    component: BuildingComponent,
    canActivate: [OfflineGuard, LoggedInGuard]
  },
  {
    path: "buildings/:buildingId/jobs/:jobId",
    component: JobComponent,
    canActivate: [OfflineGuard, LoggedInGuard]
  },
  { path: "**", redirectTo: "/login" }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
